import { render } from "./MenuMobile.vue?vue&type=template&id=4bdb525e&scoped=true"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=4bdb525e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdb525e"]])

export default __exports__